import { events } from '../../../../__lib__/perseus/events'
import type { PickAnalyticsEventAttributes } from '../../../../types'

export const TestEventPerseus = (attributes: PickAnalyticsEventAttributes<'TestEventPerseus'>) => {
  const { TestEventPerseus } = events
  new TestEventPerseus(attributes)
}
